import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const booleanNodeSpec: NodeSpec<NodeCfg<'boolean'>> = {
    inputs: () => ({}),
    validator: () => true,
    requiredSockets: 'all',
    nodeCategory: 'boolean',
    kindLabel: 'Boolean Value',
    cfg: () => ({ controlValues: { value: true }, id: getUID(), kind: 'boolean', disabled: false }),
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    controls: nodeCfg => ({
        value: defineControlOpts({
            cfg: { kind: 'boolean', label: 'Value' },
            value: nodeCfg.controlValues.value,
            on: { 'update:value': defaultControlUpdateValueHandler },
        }),
    }),
};
